export default __webpack_public_path__ + "static/media/banese_refinado.70799bc8.jpg";